"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

// Throws an error when a required param is not found
function requireParam(paramName) {
  var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Error';
  throw new Error("".concat(context, ": required param ").concat(paramName, " not provided"));
}

var _default = requireParam;
exports["default"] = _default;